import { useEffect } from 'react';
import { useWebSocket } from '../contexts/WebSocketContext';
import { toast } from 'sonner';

const WebSocketNotifier = () => {
  const ws = useWebSocket();

  useEffect(() => {
    if (!ws) return;

    const unsubNotif = ws.subscribe('notification', (data) => {
      toast.info(data.title || 'New notification', {
        description: data.message,
        duration: 5000,
      });
    });

    const unsubConv = ws.subscribe('new_conversation', (data) => {
      toast.info(`${data.fromName} started a conversation`, {
        description: 'Check your inbox to respond',
        duration: 5000,
      });
    });

    const unsubMsg = ws.subscribe('new_message', (data) => {
      toast.info(`New message from ${data.fromName || 'a planner'}`, {
        description: data.preview || 'You have a new message',
        duration: 5000,
      });
    });

    return () => {
      unsubNotif();
      unsubConv();
      unsubMsg();
    };
  }, [ws]);

  return null;
};

export default WebSocketNotifier;
